<template>
  <div class="dropdown-wrap">
    <el-dropdown trigger="click" placement="bottom-start">
      <span class="el-dropdown-link">
        <slot name="head"></slot>
      </span>
      <el-dropdown-menu slot="dropdown" v-if="!isHide">
        <slot name="body">
          <el-dropdown-item
            :class="defaultVal === item.name ? 'active' : ''"
            v-for="(item, index) in data" @click.native="handleClick(item, index)" :key="index">
            <div class="capitalize">
              {{ item.name }}
            </div>
          </el-dropdown-item>
        </slot>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'DropDown',
  props: {
    data: Array,
    defaultVal: [String, Number],
    isHide: Boolean
  },
  data () {
    return {
      checkedIndex: -1
    }
  },
  methods: {
    handleClick (item, index) {
      this.checkedIndex = index
      this.$emit('select', item, index)
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../common/style/theme');

.el-dropdown-menu {
  background-color: @color-primary;
}
/deep/ .popper__arrow {
  display: none;
}
.el-popper[x-placement^=bottom] {
  margin: 2px 0 0;
}
.el-dropdown-menu__item {
  line-height: 30px;
  color: #fff;
}
.el-dropdown-menu__item:not(.is-disabled):hover, .active {
  background-color: @color-blue;
  color: #fff;
}
</style>
